let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bqY6W")).then(() => parcelRequire('38Wdr'));